import { ReminderCallService } from '@/services/admin/ReminderCallService'
import { QueryBuilder } from '@/utilities/queryBuilder'

import { REMINDERS } from '@/constants/reminderType'

export const namespaced = true

export const state = {
  reminder_calls: [],
  reminder_calls_for_guarantor: []
}

export const mutations = {
  SET_REMINDER_CALLS(state, reminderCalls) {
    state.reminder_calls = reminderCalls.data
  },
  SET_REMINDER_CALLS_FOR_GUARANTOR(state, reminderCallsForGuarantor) {
    state.reminder_calls_for_guarantor = reminderCallsForGuarantor.data
  }
}

export const actions = {
  getReminderCalls({ commit }, query) {
    return new Promise(resolve => {
      let reminderCallService = new ReminderCallService()

      let queryBuilder = new QueryBuilder()
      let newQuery = queryBuilder
        .where('order_id', query.order_id)
        .where('reminder_id', REMINDERS.DELIVERY_REMINDER)
        .include('activity')
        .append('done_activity')
        .get()

      reminderCallService.getReminderCalls(newQuery).then(response => {
        commit('SET_REMINDER_CALLS', response)
        resolve(response.data)
      })
    })
  },
  getReminderCallsForGuarantor({ commit }, query) {
    return new Promise(resolve => {
      let reminderCallService = new ReminderCallService()

      let queryBuilder = new QueryBuilder()
      let newQuery = queryBuilder
        .where('order_id', query.order_id)
        .where('reminder_id', REMINDERS.GUARANTOR_CONFIRMATION)
        .include('activity')
        .append('done_activity')
        .get()

      reminderCallService.getReminderCalls(newQuery).then(response => {
        commit('SET_REMINDER_CALLS_FOR_GUARANTOR', response)
        resolve(response.data)
      })
    })
  }
}

export const getters = {
  reminder(state) {
    return state.reminder_calls.find(call => call.option && !call.is_done)
  },
  reminders(state) {
    return state.reminder_calls.filter(call => call.is_done)
  },
  reminderForGuarantor(state) {
    return state.reminder_calls_for_guarantor.find(call => call.option && !call.is_done)
  },
  remindersForGuarantor(state) {
    return state.reminder_calls_for_guarantor.filter(call => call.is_done)
  }
}
